import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';
import {msg} from '@lit/localize';

import {ConfigurationInterpreter} from '@viamedici-spc/configurator-ts';
import store from '../../store';
import {
	selectProductDatas,
	selectSectionConfig,
	selectSpcConfigurations,
	selectSpcSessions
} from '../../selectors';
import {stringToAttributeId} from './util/spcUtils';
import {filterAndJoin} from '../../util/filterAndJoin';
import {pimText, pimTextDebug} from '../../util/values';

@customElement('spc-values-label')
export class SpcValuesLabel extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {
			}

		`];

	@property({type: String})
	attributeKey = {};

	@property({type: String})
	context = 'FV.S';

	@property({type: String})
	suffix = '';

	@property({type: String})
	display = null; // list, max, range, selected

	@property({type: String})
	instanceId = 'default';

	@property({type: Boolean})
	showIdWhenMissing = false;

	@property({type: Object})
	replace = null;

	constructor() {
		super();
		this.translations = {};
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.debug = state.status.debug;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.unitSuffix = '';

		//this.attributeId = stringToAttributeId(this.attributeKey);
		//this.context = 'FV.S';

		this.sectionConfig = selectSectionConfig(state);
		this.section = this.sectionConfig[0];

		this.session = selectSpcSessions(state)[this.instanceId];
		if (!this.session) return;

		this.deploymentName = this.session.getSessionContext().configurationModelSource.deploymentName;
		const productDatas = selectProductDatas(state);

		if (Object.hasOwn(productDatas, this.deploymentName)) {
			this.translations = productDatas[this.deploymentName].translations;
		}

		const spcConfigurations = selectSpcConfigurations(state);
		if (spcConfigurations && Object.hasOwn(spcConfigurations, this.instanceId)) {
			this.spcConfiguration = spcConfigurations[this.instanceId];
		}
		if (this.spcConfiguration) {
			this.attribute = ConfigurationInterpreter.getChoiceAttribute(this.spcConfiguration, this.attributeKey);
			if (this.attribute) {
				this.specSheetValuesDisplay = this.section.attributeOptions?.[this.attribute.key]?.specSheetValuesDisplay ?? 'list';
				this.unit = this.section.attributeOptions?.[this.attribute.key]?.unit ?? '';
				if (this.unit !== '') {
					this.unitSuffix = ' ' + this.unit + this.suffix;
				}
				this.values = Array.from(this.attribute.values.values()).filter(v => v.possibleDecisionStates.includes('Included'));
			}
		}
		if (this.display === null) {
			this.display = this.specSheetValuesDisplay;
		}
	}

	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}

	t(attributeKey, context, valueId, prefix, suffix) {
		return this.debug ?
			pimTextDebug(this.lang, attributeKey, context, this.spcConfiguration, this.translations, valueId, prefix, suffix) :
			pimText(this.lang, attributeKey, context, this.spcConfiguration, this.translations, valueId, prefix, suffix, '', false);
	}

	render() {
		if (!this.values) return null;
		//console.log('values', this.values);
		if(this.display === 'selected' || this.isSatisfied()) {
			return html`
				<trans-label instanceId="${this.instanceId}" slot="value" class="value" key="${this.attributeKey}" context="${this.context}" suffix=${this.unitSuffix} .showIdWhenMissing=${this.showIdWhenMissing}></trans-label>`;
		} else {
			const valueLabels = this.values
				.map(value => {
					// console.log(this.attributeId.localId, value.id, this.replace);
					if (this.replace !== null && this.replace.hasOwnProperty(value.id)) {
						return this.replace[value.id];
					} else {
						return this.t(this.attributeKey, this.context, value.id);
					}
				});
			switch(this.display) {

				case 'max': // max. 123, last item in value list
					return 'max. ' + valueLabels.pop() + ' ' + this.unitSuffix;

				case 'range': // 123 - 345
					return valueLabels.length <= 2 ? html`${filterAndJoin(valueLabels, ', ')}` :
						html`${valueLabels[0]} - ${valueLabels.pop()} ${this.unitSuffix}`;

				default: // 123, 345, 456, 678, ... (23 more)
					return valueLabels.length <= 24 ? html`${filterAndJoin(valueLabels, ', ')}` :
						html`${filterAndJoin(valueLabels.slice(0, 24), ', ')}, ... (${(valueLabels.length - 24)} ${msg('more')})}`;
			}
		}
	}
}
